module.exports = __webpack_public_path__ + "img/solicitudes-icon.4c184241.svg";